const { $ } = window
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
export default {
	init() {
		// GSAP Front-Page Animations
		gsap
			.timeline({
				defaults: { duration: 0.35, opacity: 0, ease: 'power1.out' },
				onComplete() {
					// ScrollTrigger.create({
					// 	trigger: $('.hero-stats'),
					// 	start: 'center bottom',
					// 	onEnter: () => {
							// $('.stat-heading span').each(function () {
							// 	let $this = $(this),
							// 		countTo = $this.attr('data-count')

							// 	$({ countNum: $this.text() }).animate(
							// 		{
							// 			countNum: countTo,
							// 		},
							// 		{
							// 			duration: 1000,
							// 			easing: 'linear',
							// 			step() {
							// 				$this.text(Math.floor(this.countNum))
							// 			},
							// 			complete() {
							// 				$this.text(this.countNum)
							// 			},
							// 		}
							// 	)
							// })
					// 	},
					// })
				},
			})
			.from('.page-template-front-page .hero .hero-img', {})
			.from(
				'.page-template-front-page .hero-content .pre-heading-btn',
				{},
				'-=0.25'
			)
			.from(
				'.page-template-front-page .hero-content h2',
				{
					xPercent: 10,
					stagger: { each: 0.01 },
				},
				'-=0.25'
			)
			.from(
				'.page-template-front-page .hero-content p:not(.pre-heading-btn)',
				{
					yPercent: 10,
				},
				'-=0.25'
			)
			.from('.page-template-front-page .hero-stats', { y: 20 }, '-=.35')
			.from('.page-template-front-page .hero-stat', { y: 8, stagger: 0.05 })

		// Home — Reasons Section
		// let reasons = gsap.utils.toArray('.home-reason')
		// reasons.forEach((reason, i) => {
		// 	gsap.from(reason, {
		// 		scrollTrigger: { trigger: reason, start: 'top 90%', end: '+=30%' },
		// 		opacity: 0,
		// 		yPercent: 20,
		// 		delay: i * 0.1,
		// 		ease: 'power2.out',
		// 	})
		// 	// .from(reason, {})
		// })
		let reasons = document.querySelectorAll('.home-reason')
		gsap.to(reasons, {
			scrollTrigger: {
				trigger: reasons,
				start: 'top 90%',
				end: '+=30%'
			 },
			opacity: 1,
			y: 0,
			stagger: 0.1,
		})

		// Home — Portfolio Logos
		let portfolioImg = document.querySelectorAll('.home-portfolio-grid img')
		gsap.from(portfolioImg, {
			scrollTrigger: {
				trigger: portfolioImg,
				start: 'top 90%',
			},
			y: -20,
			opacity: 0,
			stagger: 0.1,
			duration: 0.3,
		})

		animateStrategies()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS

		//parallax on home/about hero
		document.querySelector('.hero-stats').classList.add('parallax')
		// eslint-disable-next-line no-undef
		const instance = basicScroll.create({
			elem: document.querySelector('.hero-stats'),
			from: 'top-bottom',
			to: 'bottom-top',
			props: {
				'--heroStats': {
					from: '5px',
					to: '-100px',
				},
			},
		})

		instance.start()

		let initVal = 30
		$('.home-people .decor-img').each(function (_idx, el) {
			initVal += Math.floor(Math.random() * 15)
			// console.log(initVal)

			// eslint-disable-next-line no-undef
			const instance = basicScroll.create({
				elem: el,
				from: 'top-bottom',
				to: 'bottom-top',
				props: {
					[`--hpimg${_idx}`]: {
						from: `${initVal * -1}px`,
						to: `${initVal}px`,
					},
				},
			})

			instance.start()
		})
	},
}

function animateStrategies() {
	const cards = document.querySelectorAll(
		'.home-strategies-card-wrap .home-strategies-card'
	)

	const disclaimers = document.querySelectorAll('.disclaimer')

	gsap.to(disclaimers, {
		scrollTrigger: {
			trigger: disclaimers,
			start: 'top 90%',
		},
		opacity: 1,
		stagger: 0.1,
		y: 0,
	})

	gsap.to(cards, {
		scrollTrigger: {
			trigger: cards,
			start: 'top 90%',
		},
		opacity: 1,
		stagger: 0.1,
	})
}
